import { ScrollArea } from "./ui/scroll-area";
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";
import { AspectRatio } from "./ui/aspect-ratio";
const Integrations = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });
  const platforms = [{
    name: "Meta",
    iconSrc: "/logos/meta.png"
  }, {
    name: "Google Ads",
    iconSrc: "/logos/google-ads.png"
  }, {
    name: "TikTok",
    iconSrc: "/logos/tiktok.png"
  }, {
    name: "Shopify",
    iconSrc: "/logos/shopify.png"
  }];
  return <div className="px-6">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`bg-white rounded-2xl p-8 transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl md:text-5xl font-charter mb-8 text-center">
            All your data.<br className="md:hidden" /> One platform.
          </h2>
          <p className="text-center text-muted-foreground mb-6 md:mb-12 max-w-2xl mx-auto">
            Seamlessly connect with your favorite platforms and tools to streamline your workflow.
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 border-2 border-dashed border-gray-300 rounded-xl p-6">
            {platforms.map((platform, index) => <div key={index} className="flex items-center justify-center p-4 px-0">
                <img src={platform.iconSrc} alt={platform.name} className="w-20 h-20 md:w-24 md:h-24 object-contain transition-all duration-300" />
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};
export default Integrations;